import { ActionCreator } from 'redux';
import { TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY } from './constants';
import { ToggleNetworkLoadingSpinnerVisibilityAction } from './type';


export const toggleNetworkLoadingSpinnerVisibility: ActionCreator<ToggleNetworkLoadingSpinnerVisibilityAction> = (visible: boolean) => ({
    type: TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY,
    payload: {
        visible
    },
});



// WEBPACK FOOTER //
// ./src/store/LoadingSpinner/actions.ts